import InfiniteScrollList from './InfiniteScrollList'

export default InfiniteScrollList
